import { __assign } from "tslib";
import { computeStackTrace, formatUnknownError, startAutomaticErrorCollection, } from '@datadog/browser-core';
import { RumEventType } from '../../../rawRumEvent.types';
import { LifeCycleEventType } from '../../lifeCycle';
export function startErrorCollection(lifeCycle, configuration) {
    startAutomaticErrorCollection(configuration).subscribe(function (error) {
        return lifeCycle.notify(LifeCycleEventType.RAW_ERROR_COLLECTED, { error: error });
    });
    return doStartErrorCollection(lifeCycle);
}
export function doStartErrorCollection(lifeCycle) {
    lifeCycle.subscribe(LifeCycleEventType.RAW_ERROR_COLLECTED, function (_a) {
        var error = _a.error, customerContext = _a.customerContext, savedCommonContext = _a.savedCommonContext;
        lifeCycle.notify(LifeCycleEventType.RAW_RUM_EVENT_COLLECTED, __assign({ customerContext: customerContext,
            savedCommonContext: savedCommonContext }, processError(error)));
    });
    return {
        addError: function (_a, savedCommonContext) {
            var error = _a.error, startClocks = _a.startClocks, customerContext = _a.context, source = _a.source;
            var rawError = computeRawError(error, startClocks, source);
            lifeCycle.notify(LifeCycleEventType.RAW_ERROR_COLLECTED, {
                customerContext: customerContext,
                savedCommonContext: savedCommonContext,
                error: rawError,
            });
        },
    };
}
function computeRawError(error, startClocks, source) {
    var stackTrace = error instanceof Error ? computeStackTrace(error) : undefined;
    return __assign({ startClocks: startClocks, source: source }, formatUnknownError(stackTrace, error, 'Provided'));
}
function processError(error) {
    var rawRumEvent = {
        date: error.startClocks.timeStamp,
        error: {
            message: error.message,
            resource: error.resource
                ? {
                    method: error.resource.method,
                    status_code: error.resource.statusCode,
                    url: error.resource.url,
                }
                : undefined,
            source: error.source,
            stack: error.stack,
            type: error.type,
        },
        type: RumEventType.ERROR,
    };
    return {
        rawRumEvent: rawRumEvent,
        startTime: error.startClocks.relative,
    };
}
//# sourceMappingURL=errorCollection.js.map